import { render, staticRenderFns } from "./OrganismClearCache.vue?vue&type=template&id=0610f380"
import script from "./OrganismClearCache.vue?vue&type=script&lang=js"
export * from "./OrganismClearCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports